import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { sortAlphabetically } from '@as-react/common-utils';
import { HtmlInclude, ScriptTypes } from '../../common/html-include/HtmlInclude';
const generateBrandsSchema = (brands, origin, brandImageCdnUrl) => {
    const getBrandUrl = (relativePath) => {
        const cleanPath = relativePath.replace(/^\/+/, '').replace(/\/+$/, '');
        return `${origin}/${cleanPath}`;
    };
    const getBrandLogoUrl = (logo) => {
        const base = new URL(brandImageCdnUrl, origin).toString();
        return new URL(logo.replace(/^\/+/, ''), base.endsWith('/') ? base : `${base}/`).toString();
    };
    return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: brands.map((brand, index) => ({
            '@type': 'ListItem',
            position: String(index + 1),
            item: {
                '@type': 'Brand',
                name: brand.description,
                url: getBrandUrl(brand.relativePath),
                logo: getBrandLogoUrl(brand.logo),
            },
        })),
    };
};
export const BrandListerJsonLd = ({ items }) => {
    const { canonicalUrl, brandImageCdnUrl } = useAemConfig();
    const { origin } = new URL(canonicalUrl);
    const itemKeys = sortAlphabetically(Object.keys(items));
    const displayedBrands = itemKeys.flatMap(itemKey => { var _a; return (_a = items[itemKey]) !== null && _a !== void 0 ? _a : []; });
    const brandsSchema = generateBrandsSchema(displayedBrands, origin, brandImageCdnUrl);
    return _jsx(HtmlInclude, { scriptFragment: JSON.stringify(brandsSchema, null, 2), scriptType: ScriptTypes.LD_JSON });
};
